import { render, staticRenderFns } from "./Zusatzleistung.vue?vue&type=template&id=4e3c67e9&scoped=true"
import script from "./Zusatzleistung.vue?vue&type=script&lang=js"
export * from "./Zusatzleistung.vue?vue&type=script&lang=js"
import style0 from "./Zusatzleistung.vue?vue&type=style&index=0&id=4e3c67e9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e3c67e9",
  null
  
)

export default component.exports